import {
    FormInputType,
    QuestionOptionType,
    type QuestionData,
} from '../support.type';
import { formFieldFactory } from '../form-fields/formFieldFactory';
import { EditableQuestion } from './EditableQuestion';
import { LinkQuestion } from './LinkQuestion';
import { Question } from './Question';
import { BillQuestion } from './BillQuestion';

export function QuestionFactory(question: QuestionData) {
    switch (question.questionOptionType) {
        case QuestionOptionType.Editable:
            return new EditableQuestion(
                question,
                formFieldFactory({
                    value: question.value,
                    persianTitle: question.title,
                    title: question.title,
                    key: question.key,
                    description: question.subTitle,
                    formInputType: FormInputType.Text,
                    regexPattern: question.validationRegex,
                    isRequired: true,
                })
            );

        case QuestionOptionType.Link:
            return new LinkQuestion(question, question.value ?? '/');
        case QuestionOptionType.ChooseBill:
            return new BillQuestion(question);
        default:
            return new Question(question);
    }
}
